import imageApi from '@innovyze/stylovyze/lib/apis/images.api';
export const getFullImageList = async (params) => {
    const limit = params?.limit || 5000;
    const sortBy = params?.sortBy || 'lastModifiedTimestamp:desc';
    const firstImageListResponse = await imageApi.get('/images', {
        params: {
            limit,
            sortBy,
        },
    });
    const { pagination, images } = firstImageListResponse.data;
    if (pagination.pages === 1)
        return images;
    const promises = new Array(pagination.pages)
        .fill(undefined)
        .map((_, index) => {
        if (index === 0)
            return Promise.resolve(firstImageListResponse);
        const imageListResponse = imageApi.get('/images', {
            params: {
                sortBy,
                limit,
                offset: index + 1,
            },
        });
        return imageListResponse;
    });
    const results = await Promise.all(promises);
    const fullImageList = results.reduce((acc, result) => {
        return [...acc, ...result.data.images];
    }, []);
    return fullImageList;
};
